<div class="banner justify-content-center" role="banner">
  <h1 class="text-white">{{ 'worksheet.gallery.title' | translate }}</h1>
</div>
<fgb-worksheet-list></fgb-worksheet-list>
